module.exports = __webpack_public_path__ + "img/工厂.22bca860.png";